import BrevetFiltersSubthemeSelection from "./BrevetFiltersSubthemeSelection";
import BrevetFiltersGradeSelection from "./BrevetFiltersGradeSelection";
import BrevetFiltersMediaSelection from "./BrevetFiltersMediaSelection";
import {isNullOrUndefined} from "../../../services/Validator";

export default function BrevetFiltersContent({availableFilters, draftFilters, handleToggleGrade, handleToggleSubtheme}) {
    // Used in BrevetFiltersDialog to display Modal content

    // BUILD
    if (isNullOrUndefined(availableFilters) || isNullOrUndefined(draftFilters))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 grow flex flex-col justify-start px-[24px] py-[20px]"}>
            <BrevetFiltersSubthemeSelection availableSubthemes={availableFilters?.subthemes}
                                            draftSubthemes={draftFilters.subthemes}
                                            handleToggleSubtheme={handleToggleSubtheme} />
            <BrevetFiltersGradeSelection availableGrades={availableFilters?.grades}
                                         draftGrades={draftFilters.grades}
                                         handleToggleGrade={handleToggleGrade} />
            <BrevetFiltersMediaSelection availableMedia={availableFilters?.media}
                                         appliedMedia={draftFilters.media} />
        </div>
    );
}